module.exports = __webpack_public_path__ + "static/media/woman-placeholder.b7693897.png";